// A chave publishable é pública por design: quem protege os dados é a RLS
// (ADR-0002). Segredos de verdade só existem em Edge Functions.
export const SUPABASE_URL = 'https://pskpnargkpiwmsmbsyky.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY =
  'sb_publishable_ODntXbAZrqtQYEpB8EWtfg_Irq6-ktI';

// A PWA instalada só aceita atualização da origem exata em que foi
// instalada (CLAUDE.md), e o RP ID das passkeys é fixado nesta origem
// (spec §5): em `localhost` ou numa pré-visualização de PR o WebAuthn até
// existe, mas o registro falha com erro cru de RP ID divergente. Por isso
// os botões de Face ID só aparecem aqui.
export const ORIGEM_DE_PRODUCAO = 'https://sheafyield.mubacode.com';
